import { Route, Switch } from "react-router-dom";
import Address from "./pages/Address";
import GiftCard from "./pages/GiftCard";
import NotFound from "./pages/NotFound";
import Price from "./pages/Price";
// import ProjectStopped from "./pages/ProjectStopped";
import Result from "./pages/Result";

const Routes = (): JSX.Element => {
  return (
    <Switch>
      {/* Comment */}
      <Route path="/" exact component={GiftCard} />
      <Route path="/addresses" exact component={Address} />
      <Route path="/price" exact component={Price} />
      <Route path="/final-result" exact component={Result} />

      <Route path="*" component={NotFound} />
      {/* <Route path="/" exact component={ProjectStopped} /> */}
    </Switch>
  );
};

export default Routes;
